const Config = {
  appName: 'LightCo Lab',
  options: require('../../public/main.config'),
  scenes: {
    debug: false,
    developHelpers: false,
    autoRotate: false,
    instructionsShow: false,
    default: require('../../public/scenes/config/default.config'),
    main: require('../../public/scenes/config/gallery_opt.config'),
    main2: require('../../public/scenes/config/gallery.config'),
    embedded: [
      require('../../public/scenes/config/exhibits/exhibit-1.config'),
      require('../../public/scenes/config/exhibits/exhibit-2.config'),
      require('../../public/scenes/config/exhibits/exhibit-3.config'),
      require('../../public/scenes/config/exhibits/exhibit-4.config'),
      require('../../public/scenes/config/exhibits/exhibit-5.config'),
      require('../../public/scenes/config/exhibits/exhibit-6.config'),
      require('../../public/scenes/config/exhibits/exhibit-7.config'),
      require('../../public/scenes/config/exhibits/exhibit-8.config'),
      require('../../public/scenes/config/exhibits/exhibit-9.config'),
      require('../../public/scenes/config/exhibits/exhibit-10.config'),
      require('../../public/scenes/config/exhibits/exhibit-11.config'),
      require('../../public/scenes/config/exhibits/exhibit-12.config')
    ],
    templates: [
      require('../../public/scenes/config/templates/template-1.config'),
      require('../../public/scenes/config/templates/template-2.config'),
      require('../../public/scenes/config/templates/template-3.config'),
      require('../../public/scenes/config/templates/template-4.config'),
      require('../../public/scenes/config/templates/template-5.config')
    ],
    objects: [
      require('../../public/scenes/config/objects/oblong-seaters.config'),
      require('../../public/scenes/config/objects/light-sources-butterfly.config')
    ]
  }
}

export default Config
